'use strict';

define(function (require, exports, module) {
    var debounce = require('./debounce');

    var headerEl = document.querySelector('.header'); // if any sections with no header.

    if (!headerEl) {
        return;
    }

    var headerNav = headerEl.querySelector('.header__navigation') || {};
    var primaryNav = headerNav.querySelector('.header__nav-items') || {};
    var secondaryNav =
        headerNav.querySelector('.header__nav-items--secondary') || {};
    var primaryItems =
        primaryNav.querySelectorAll('.header__nav-item-link') || [];
    var moreItems = headerNav.querySelector('.header__nav-items--more') || {};
    var moreList = moreItems.querySelector('.header__nav-item-body--more') || {};
    var nodeMap = [];
    var burgerBreakpoint = 1023;

    var getViewport = function getViewport() {
        var viewPortWidth = null;
        var viewPortHeight = null;

        if (typeof window.innerWidth !== 'undefined') {
            viewPortWidth = window.innerWidth;
            viewPortHeight = window.innerHeight;
        } else if (
            typeof document.documentElement !== 'undefined' &&
            typeof document.documentElement.clientWidth !== 'undefined' &&
            document.documentElement.clientWidth !== 0
        ) {
            viewPortWidth = document.documentElement.clientWidth;
            viewPortHeight = document.documentElement.clientHeight;
        } else {
            viewPortWidth = document.getElementsByTagName('body')[0]
                .clientWidth;
            viewPortHeight = document.getElementsByTagName('body')[0]
                .clientHeight;
        }

        return [viewPortWidth, viewPortHeight];
    };

    var viewPortWidth = getViewport()[0];
    var resizeCount = 0;

    function shiftNavItems(spaceBetween) {
        // Depending on whether the space between the primary and secondary navs
        // is above or below the threshold, this function loops through primary items
        // and either adds or removes them to find the best fit, to get as close to the
        // threshold as possible. This feature may be reassessed in the near future.
        var currentSpace = spaceBetween;

        if (currentSpace < 240) {
            for (var i = primaryItems.length - 1; i >= 0; i--) {
                if (
                    currentSpace < 240 &&
                    !primaryItems[i].classList.contains('moved')
                ) {
                    currentSpace += primaryItems[i].offsetWidth;
                    primaryItems[i].classList.add('moved');
                    var nodeRef = primaryItems[i].cloneNode(true);
                    nodeRef.classList.add('header__nav-item-link-secondary');
                    nodeRef.classList.remove('header__nav-item-link');
                    moreList.insertBefore(nodeRef, moreList.childNodes[0]);
                }
            }
        } else {
            for (var _i = 0; _i < primaryItems.length; _i++) {
                if (
                    currentSpace - (primaryItems[_i].offsetWidth + 1) >= 240 &&
                    primaryItems[_i].classList.contains('moved')
                ) {
                    primaryItems[_i].classList.remove('moved');

                    moreList.removeChild(moreList.children[0]);
                    currentSpace -= primaryItems[_i].offsetWidth;
                }
            }
        }

        if (moreList.children && moreList.children.length) {
            let viewableItemLen = 0;
            for (let idx = 0; idx < moreList.children.length; idx++) {
                if (!moreList.children[idx].classList.contains('desktopfalse')) {
                    viewableItemLen++;
                }
            }
            if (viewableItemLen) {
                if (viewableItemLen > 6) {
                    moreList.classList.add('header__nav-item-body--two-column');
                } else {
                    moreList.classList.remove('header__nav-item-body--two-column');
                }
                moreItems.classList.remove('hide');
            } else {
                moreItems.classList.add('hide');
            }
        } else {
            moreItems.classList.add('hide');
        }

        headerNav.classList.add('header__navigation-shifted');
        primaryNav.classList.add('header__nav-items-shifted');
        secondaryNav.classList.add('header__nav-items--secondary-shifted');
        moreItems.classList.add('header__nav-items--more-shifted');
    } // Run on load and resize

    var handleEllipsis = debounce(function () {
        try {
            var newViewPortWidth = getViewport()[0];

            if (newViewPortWidth !== viewPortWidth || resizeCount === 0) {
                var thirdParty =
                    headerEl.getAttribute('data-is-third-party') === 'true';
                var narrowBefore =
                    typeof viewPortWidth === 'number' &&
                    viewPortWidth <= burgerBreakpoint;
                var wideNow = newViewPortWidth > burgerBreakpoint;

                if (wideNow && !thirdParty) {
                    var spaceBetween =
                        headerNav.offsetWidth -
                        primaryNav.offsetWidth -
                        secondaryNav.offsetWidth;
                    shiftNavItems(spaceBetween);
                } else if (thirdParty) {
                    headerNav.classList.add('header__navigation-shifted');
                    primaryNav.classList.add('header__nav-items-shifted');
                    secondaryNav.classList.add(
                        'header__nav-items--secondary-shifted'
                    );
                } else {
                    headerNav.classList.add('header__navigation-shifted');
                    primaryNav.classList.remove('header__nav-items-shifted');
                    secondaryNav.classList.add(
                        'header__nav-items--secondary-shifted'
                    );
                    moreItems.classList.remove(
                        'header__nav-items--more-shifted'
                    );
                }

                resizeCount++;
                viewPortWidth = newViewPortWidth;
            }
        } catch (err) {
            console.error(err);
        }
    }, 50);

    handleEllipsis();
    window.addEventListener('resize', handleEllipsis);
    var navIcon = headerEl.querySelector('.header__hamburger');
    var navMobile = headerEl.querySelector('.header__mobile-nav');
    var secondaryNavList = headerEl.querySelector(
        '.header__nav-items--secondary'
    );
    var navItemWithDropdown = secondaryNavList.querySelector(
        '.header__nav-item--persisted'
    ); // no scroll and overlay on body

    var toggleNoScroll = function toggleNoScroll() {
        var mainContent = document.getElementsByTagName('main');
        document.body.classList.toggle('no-scroll');

        if (mainContent.length) {
            mainContent[0].classList.toggle('disabled');
        }
    }; // hamburger menu

    var toggleMobileMenu = function toggleMobileMenu() {
        toggleNoScroll();
        navIcon.classList.toggle('open');
        navMobile.classList.toggle('open');

        if (document.body.classList.contains('no-scroll')) {
            var headerHeight = headerNav.clientHeight;
            var heightDiff = window.outerHeight - window.innerHeight;
            var mobileMenuHeight = 'calc(100vh - '.concat(
                headerHeight + heightDiff,
                'px)'
            );
            navMobile.style.maxHeight = mobileMenuHeight;
        }
    }; // persisted item dropdown (ie Teams on league pages)

    var togglePersistedDropDown = function togglePersistedDropDown() {
        toggleNoScroll();
        navItemWithDropdown.classList.toggle('open');

        if (document.body.classList.contains('no-scroll')) {
            var dropdownBody = navItemWithDropdown.querySelector(
                '.header__nav-item-body'
            );
            var headerHeight = headerNav.clientHeight;
            var heightDiff = window.outerHeight - window.innerHeight;
            var mobileMenuHeight = 'calc(100vh - '.concat(
                headerHeight + heightDiff,
                'px)'
            );
            dropdownBody.style.maxHeight = mobileMenuHeight;
        }
    };

    if (navIcon) {
        navIcon.addEventListener('click', function () {
            if (
                navItemWithDropdown &&
                navItemWithDropdown.classList.contains('open')
            ) {
                togglePersistedDropDown();
            }

            toggleMobileMenu();
        });
    }

    if (navItemWithDropdown) {
        var navDropdownLogic = function (e) {
            var target = e.target; //close hamburger menu if open

            if (navIcon && navIcon.classList.contains('open')) {
                toggleMobileMenu();
            } // have to allow scrolling within

            if (target.nodeName === 'LI' || target.nodeName === 'SPAN') {
                togglePersistedDropDown();
            }
        };

        navItemWithDropdown.addEventListener('click', navDropdownLogic);
    } // Handle Logged In state

    if (window.mlbOkta) {
        window.mlbOkta.isLoggedIn().then(function (data) {
            if (data && data.loggedIn) {
                var headerAccount = document.querySelector('.header__account');
                headerAccount.setAttribute('data-is-logged-in', 'true');
            }
        });
    }

    var searchJS = require('./search');
});
